import * as React from "react";
const LinkedIn = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={48}
    viewBox="0 0 58 48"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_885_47172"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={58}
      height={48}
    >
      <rect width={58} height={48} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_885_47172)">
      <g filter="url(#filter0_f_885_47172)">
        <path
          d="M3 21C3 24.1517 3.6337 27.2726 4.86494 30.1844C6.09618 33.0962 7.90084 35.742 10.1759 37.9706C12.4509 40.1992 15.1518 41.967 18.1243 43.1731C21.0967 44.3792 24.2826 45 27.5 45C30.7174 45 33.9033 44.3792 36.8757 43.1731C39.8482 41.967 42.5491 40.1992 44.8241 37.9706C47.0992 35.742 48.9038 33.0962 50.1351 30.1844C51.3663 27.2726 52 24.1517 52 21L27.5 21L3 21Z"
          fill="#6039DB"
          fillOpacity={0.09}
        />
      </g>
      <rect x={31} y={36} width={11} height={11} rx={2} fill="#007EBB" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 44.5H38.6645V42.2253C38.6645 41.6016 38.4275 41.2531 37.9338 41.2531C37.3968 41.2531 37.1163 41.6158 37.1163 42.2253V44.5H35.8292V40.1667H37.1163V40.7504C37.1163 40.7504 37.5033 40.0343 38.4228 40.0343C39.342 40.0343 40 40.5956 40 41.7564V44.5ZM34.2937 39.5993C33.8553 39.5993 33.5 39.2412 33.5 38.7996C33.5 38.358 33.8553 38 34.2937 38C34.7321 38 35.0871 38.358 35.0871 38.7996C35.0871 39.2412 34.7321 39.5993 34.2937 39.5993ZM33.6291 44.5H34.9712V40.1667H33.6291V44.5Z"
        fill="white"
      />
      <path
        d="M9.395 27.9101L9.388 27.9071L9.366 27.8951C9.23729 27.8243 9.10961 27.7516 8.983 27.6771C7.46081 26.7726 6.03827 25.71 4.739 24.5071C2.438 22.3601 0 19.1741 0 15.2501C0 12.3221 2.464 10.0001 5.438 10.0001C6.26475 9.99602 7.08178 10.1784 7.82832 10.5337C8.57486 10.8889 9.2317 11.4079 9.75 12.0521C10.2684 11.4078 10.9254 10.8887 11.6721 10.5335C12.4189 10.1782 13.2361 9.99587 14.063 10.0001C17.036 10.0001 19.5 12.3221 19.5 15.2501C19.5 19.1751 17.062 22.3611 14.761 24.5061C13.4617 25.709 12.0392 26.7716 10.517 27.6761C10.3904 27.7509 10.2627 27.8239 10.134 27.8951L10.112 27.9071L10.105 27.9111L10.102 27.9121C9.99356 27.9695 9.87271 27.9995 9.75 27.9995C9.62729 27.9995 9.50644 27.9695 9.398 27.9121L9.395 27.9101Z"
        fill="#DA5744"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_885_47172"
        x={-5}
        y={13}
        width={65}
        height={40}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={4}
          result="effect1_foregroundBlur_885_47172"
        />
      </filter>
    </defs>
  </svg>
);

const Email = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={48}
    viewBox="0 0 58 48"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_885_37989"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={58}
      height={48}
    >
      <rect width={58} height={48} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_885_37989)">
      <g filter="url(#filter0_f_885_37989)">
        <path
          d="M3 20C3 23.1517 3.6337 26.2726 4.86494 29.1844C6.09618 32.0962 7.90084 34.742 10.1759 36.9706C12.4509 39.1992 15.1518 40.967 18.1243 42.1731C21.0967 43.3792 24.2826 44 27.5 44C30.7174 44 33.9033 43.3792 36.8757 42.1731C39.8482 40.967 42.5491 39.1992 44.8241 36.9706C47.0992 34.742 48.9038 32.0962 50.1351 29.1844C51.3663 26.2726 52 23.1517 52 20L27.5 20L3 20Z"
          fill="#6039DB"
          fillOpacity={0.09}
        />
      </g>
      <rect x={30} y={34} width={13} height={13} rx={6.5} fill="#111827" />
      <path
        d="M38.8264 42.4394C38.512 42.4394 38.2528 42.3537 38.0489 42.1825C37.8449 42.0112 37.6835 41.7628 37.5645 41.4374C37.369 41.7799 37.1014 42.0497 36.7614 42.2467C36.4215 42.4436 36.0561 42.5421 35.6652 42.5421C35.4783 42.5421 35.3125 42.5079 35.1681 42.4394C35.0321 42.3709 34.8579 42.2638 34.6455 42.1182C34.5095 42.0326 34.4075 41.8998 34.3395 41.72C34.2801 41.5316 34.2503 41.3303 34.2503 41.1162C34.2503 40.8593 34.2758 40.6324 34.3268 40.4354C34.3778 40.2384 34.45 40.0243 34.5435 39.7931C34.7984 39.1851 35.1171 38.7997 35.4995 38.637C35.7035 38.5428 35.8607 38.4786 35.9711 38.4443C36.0816 38.4015 36.2006 38.3801 36.328 38.3801C36.5575 38.3801 36.7869 38.4229 37.0164 38.5085C37.2458 38.5856 37.4285 38.7269 37.5645 38.9325C37.658 38.8126 37.743 38.7269 37.8194 38.6755C37.8959 38.6242 38.0064 38.5985 38.1509 38.5985C38.2698 38.5985 38.3676 38.6327 38.444 38.7012C38.5205 38.7697 38.5588 38.8725 38.5588 39.0095C38.5588 39.1294 38.512 39.3478 38.4185 39.6647C38.3166 40.0243 38.2656 40.2855 38.2656 40.4483C38.2656 40.7566 38.3081 41.0049 38.393 41.1933C38.4865 41.3817 38.631 41.4759 38.8264 41.4759C39.0899 41.4759 39.2768 41.3261 39.3873 41.0263C39.5063 40.718 39.5658 40.3498 39.5658 39.9216C39.5658 39.4763 39.5233 39.1209 39.4383 38.8554C39.3533 38.5899 39.2088 38.3244 39.0049 38.0589C38.8264 37.8191 38.529 37.6307 38.1126 37.4937C37.7047 37.3481 37.2926 37.2753 36.8762 37.2753C36.4598 37.2753 36.0221 37.3824 35.5632 37.5965C35.1043 37.8106 34.7644 38.0375 34.5435 38.2773C34.1441 38.6969 33.8891 39.0952 33.7787 39.472C33.6852 39.7717 33.613 40.0415 33.562 40.2813C33.511 40.5211 33.4812 40.7694 33.4727 41.0263C33.4727 41.2918 33.5152 41.5744 33.6002 41.8742C33.6852 42.1653 33.8042 42.4222 33.9571 42.6449C34.0676 42.7991 34.1993 42.9446 34.3523 43.0817C34.5052 43.2101 34.654 43.2958 34.7984 43.3386L35.1426 43.4285C35.6865 43.5741 36.0434 43.6469 36.2133 43.6469C36.5702 43.6469 36.8889 43.6169 37.1693 43.557C37.4498 43.497 37.7132 43.39 37.9597 43.2358C38.0021 43.2101 38.1126 43.1416 38.2911 43.0303C38.4695 42.9104 38.6267 42.8504 38.7627 42.8504C39.0941 42.8504 39.2598 43.0089 39.2598 43.3257C39.2598 43.5141 39.1664 43.6811 38.9794 43.8267C38.7924 43.9637 38.5248 44.1136 38.1763 44.2763C37.8534 44.4305 37.5518 44.529 37.2713 44.5718C36.9909 44.6146 36.634 44.636 36.2006 44.636C35.8947 44.636 35.4358 44.5846 34.8239 44.4819C34.2376 44.2335 33.8084 43.9766 33.5365 43.7111C33.1881 43.3942 32.9034 43.0003 32.6824 42.5293C32.47 42.0497 32.3638 41.5744 32.3638 41.1034C32.3638 40.8122 32.3978 40.5253 32.4657 40.2427C32.5337 39.9601 32.6315 39.6218 32.7589 39.2279C32.9459 38.6284 33.3283 38.0461 33.9061 37.4809C34.1951 37.1983 34.654 36.9413 35.2828 36.7101C35.9201 36.4789 36.4853 36.3633 36.9781 36.3633C37.5815 36.3633 38.0999 36.4489 38.5333 36.6202C38.9752 36.7915 39.2981 36.9628 39.502 37.134C39.9184 37.5023 40.2116 37.9133 40.3816 38.3672C40.5515 38.8211 40.6365 39.3606 40.6365 39.9858C40.6365 40.7737 40.4835 41.3389 40.1776 41.6815C39.9397 41.9469 39.7187 42.1396 39.5148 42.2595C39.3193 42.3794 39.0899 42.4394 38.8264 42.4394ZM36.4938 41.3346C36.9951 40.9407 37.2458 40.4654 37.2458 39.9087C37.2458 39.7717 37.1608 39.6304 36.9909 39.4848C36.8294 39.3307 36.6552 39.2536 36.4683 39.2536C36.2218 39.2536 36.0051 39.3392 35.8182 39.5105C35.6312 39.6818 35.4868 39.9002 35.3848 40.1657C35.2913 40.4311 35.2446 40.6966 35.2446 40.9621C35.2446 41.1334 35.2828 41.2875 35.3593 41.4245C35.4358 41.5616 35.5122 41.6344 35.5887 41.6429C35.8692 41.6515 36.1708 41.5487 36.4938 41.3346Z"
        fill="white"
      />
      <rect y={14} width={23} height={16} rx={2} fill="#52B5F9" />
      <path
        d="M10.943 22.6275C11.2799 22.8533 11.7199 22.8533 12.0568 22.6275L22.193 15.8314C23.0136 15.2812 22.6241 14.0008 21.6361 14.0008H1.36366C0.375614 14.0008 -0.0138837 15.2812 0.806779 15.8314L10.943 22.6275Z"
        fill="#111827"
        fillOpacity={0.21}
      />
    </g>
    <defs>
      <filter
        id="filter0_f_885_37989"
        x={-5}
        y={12}
        width={65}
        height={40}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={4}
          result="effect1_foregroundBlur_885_37989"
        />
      </filter>
    </defs>
  </svg>
);
const Clock = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000000"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx={12} cy={12} r={10} />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const HasEmail = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="37"
    viewBox="0 0 44 37"
    fill="none"
  >
    <mask
      id="mask0_1976_9673"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="44"
      height="37"
    >
      <rect x="0.25" y="0.5" width="43.5" height="36" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1976_9673)">
      <g filter="url(#filter0_f_1976_9673)">
        <path
          d="M2.50133 15.5039C2.50133 17.8677 2.97661 20.2083 3.90004 22.3922C4.82347 24.5761 6.17697 26.5604 7.88324 28.2318C9.58952 29.9033 11.6152 31.2292 13.8445 32.1337C16.0739 33.0383 18.4633 33.5039 20.8763 33.5039C23.2894 33.5039 25.6788 33.0383 27.9081 32.1337C30.1375 31.2292 32.1632 29.9033 33.8694 28.2318C35.5757 26.5604 36.9292 24.5761 37.8526 22.3922C38.7761 20.2084 39.2513 17.8677 39.2513 15.5039L20.8763 15.5039L2.50133 15.5039Z"
          fill="#6039DB"
          fill-opacity="0.09"
        />
      </g>
      <path
        d="M23.5011 32.0039V30.7539C23.5011 28.8683 23.5011 27.9255 24.0869 27.3397C24.6727 26.7539 25.6155 26.7539 27.5011 26.7539H30.0011C31.8867 26.7539 32.8295 26.7539 33.4153 27.3397C34.0011 27.9255 34.0011 28.8683 34.0011 30.7539V32.0039"
        stroke="#111827"
        stroke-width="2"
      />
      <circle cx="34.0011" cy="31.25" r="1.5" fill="#111827" />
      <circle cx="23.5015" cy="31.25" r="1.5" fill="#111827" />
      <path d="M28.7515 23L28.7515 26.75" stroke="#111827" stroke-width="2" />
      <rect
        x="25.7511"
        y="20.75"
        width="6"
        height="2.95312"
        rx="1.47656"
        fill="#111827"
      />
      <rect
        x="5.49866"
        y="9.5"
        width="12.75"
        height="12.75"
        rx="6.375"
        fill="#6039DB"
      />
      <path
        d="M14.1554 17.7776C13.847 17.7776 13.5928 17.6936 13.3928 17.5256C13.1928 17.3576 13.0344 17.1141 12.9177 16.7949C12.726 17.1309 12.4635 17.3954 12.1301 17.5886C11.7967 17.7818 11.4384 17.8784 11.055 17.8784C10.8716 17.8784 10.7091 17.8448 10.5674 17.7776C10.4341 17.7104 10.2632 17.6054 10.0548 17.4626C9.92148 17.3786 9.82146 17.2484 9.75479 17.0721C9.69645 16.8873 9.66728 16.6899 9.66728 16.4799C9.66728 16.2279 9.69228 16.0054 9.74229 15.8122C9.79229 15.619 9.86314 15.409 9.95482 15.1822C10.2049 14.5859 10.5174 14.2079 10.8924 14.0483C11.0925 13.956 11.2467 13.893 11.355 13.8594C11.4634 13.8174 11.58 13.7964 11.7051 13.7964C11.9301 13.7964 12.1551 13.8384 12.3802 13.9224C12.6052 13.998 12.7844 14.1365 12.9177 14.3381C13.0094 14.2205 13.0928 14.1365 13.1678 14.0861C13.2428 14.0358 13.3511 14.0106 13.4928 14.0106C13.6095 14.0106 13.7053 14.0441 13.7804 14.1113C13.8554 14.1785 13.8929 14.2793 13.8929 14.4137C13.8929 14.5313 13.847 14.7455 13.7553 15.0563C13.6553 15.409 13.6053 15.6652 13.6053 15.8248C13.6053 16.1272 13.647 16.3707 13.7303 16.5555C13.822 16.7403 13.9637 16.8327 14.1554 16.8327C14.4138 16.8327 14.5971 16.6857 14.7055 16.3917C14.8222 16.0894 14.8805 15.7282 14.8805 15.3082C14.8805 14.8715 14.8388 14.5229 14.7555 14.2625C14.6721 14.0022 14.5305 13.7418 14.3304 13.4814C14.1554 13.2462 13.8637 13.0614 13.4553 12.9271C13.0553 12.7843 12.651 12.7129 12.2426 12.7129C11.8342 12.7129 11.405 12.8179 10.955 13.0278C10.5049 13.2378 10.1715 13.4604 9.95482 13.6956C9.56309 14.1071 9.31306 14.4977 9.20471 14.8673C9.11303 15.1612 9.04219 15.4258 8.99218 15.661C8.94217 15.8962 8.913 16.1398 8.90467 16.3917C8.90467 16.6521 8.94634 16.9293 9.02969 17.2233C9.11303 17.5088 9.22971 17.7608 9.37974 17.9792C9.48808 18.1304 9.61727 18.2732 9.76729 18.4075C9.91731 18.5335 10.0632 18.6175 10.2049 18.6595L10.5424 18.7477C11.0758 18.8905 11.4259 18.9619 11.5925 18.9619C11.9426 18.9619 12.2551 18.9325 12.5302 18.8737C12.8052 18.8149 13.0636 18.7099 13.3053 18.5587C13.347 18.5335 13.4553 18.4663 13.6303 18.3571C13.8054 18.2396 13.9595 18.1808 14.0929 18.1808C14.4179 18.1808 14.5805 18.3361 14.5805 18.6469C14.5805 18.8317 14.4888 18.9955 14.3054 19.1383C14.1221 19.2727 13.8595 19.4196 13.5178 19.5792C13.2011 19.7304 12.9052 19.827 12.6302 19.869C12.3552 19.911 12.0051 19.932 11.58 19.932C11.28 19.932 10.8299 19.8816 10.2299 19.7808C9.65477 19.5372 9.23388 19.2853 8.96718 19.0249C8.62546 18.7141 8.34626 18.3277 8.12956 17.8658C7.9212 17.3954 7.81702 16.9293 7.81702 16.4673C7.81702 16.1817 7.85035 15.9004 7.91703 15.6232C7.98371 15.346 8.07955 15.0143 8.20457 14.6279C8.38793 14.04 8.76298 13.4688 9.32973 12.9145C9.6131 12.6373 10.0632 12.3853 10.6799 12.1585C11.305 11.9317 11.8593 11.8184 12.3427 11.8184C12.9344 11.8184 13.4428 11.9024 13.8679 12.0703C14.3013 12.2383 14.618 12.4063 14.818 12.5743C15.2264 12.9355 15.5139 13.3386 15.6806 13.7838C15.8473 14.2289 15.9307 14.7581 15.9307 15.3712C15.9307 16.144 15.7806 16.6983 15.4806 17.0343C15.2472 17.2946 15.0305 17.4836 14.8305 17.6012C14.6388 17.7188 14.4138 17.7776 14.1554 17.7776ZM11.8676 16.6941C12.3593 16.3077 12.6052 15.8416 12.6052 15.2956C12.6052 15.1612 12.5218 15.0227 12.3552 14.8799C12.1968 14.7287 12.0259 14.6531 11.8426 14.6531C11.6009 14.6531 11.3884 14.7371 11.205 14.9051C11.0216 15.0731 10.8799 15.2872 10.7799 15.5476C10.6883 15.808 10.6424 16.0684 10.6424 16.3287C10.6424 16.4967 10.6799 16.6479 10.7549 16.7823C10.8299 16.9167 10.9049 16.9881 10.98 16.9965C11.255 17.0049 11.5509 16.9041 11.8676 16.6941Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1976_9673"
        x="-5.49866"
        y="7.50391"
        width="52.75"
        height="34"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="4"
          result="effect1_foregroundBlur_1976_9673"
        />
      </filter>
    </defs>
  </svg>
);
const AcceptLinkedInvite = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="37"
    viewBox="0 0 44 37"
    fill="none"
  >
    <mask
      id="mask0_1976_9703"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="44"
      height="37"
    >
      <rect x="0.25" y="0.5" width="43.5" height="36" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1976_9703)">
      <g filter="url(#filter0_f_1976_9703)">
        <path
          d="M1.74999 15.4961C1.74999 17.8599 2.22527 20.2005 3.14871 22.3844C4.07214 24.5683 5.42563 26.5526 7.13191 28.224C8.83818 29.8955 10.8638 31.2213 13.0932 32.1259C15.3225 33.0305 17.712 33.4961 20.125 33.4961C22.538 33.4961 24.9274 33.0305 27.1568 32.1259C29.3862 31.2213 31.4118 29.8955 33.1181 28.224C34.8244 26.5526 36.1779 24.5683 37.1013 22.3844C38.0247 20.2005 38.5 17.8599 38.5 15.4961L20.125 15.4961L1.74999 15.4961Z"
          fill="#6039DB"
          fill-opacity="0.09"
        />
      </g>
      <path
        d="M18.0667 12.3848L13.5068 17.1006L11.3785 14.9533"
        stroke="black"
        stroke-width="2"
      />
      <rect
        x="23.4985"
        y="26.7461"
        width="8.25"
        height="8.25"
        rx="2"
        fill="#007EBB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.2493 33.123H29.2476V31.417C29.2476 30.9492 29.0699 30.6878 28.6996 30.6878C28.2969 30.6878 28.0865 30.9599 28.0865 31.417V33.123H27.1211V29.873H28.0865V30.3108C28.0865 30.3108 28.3767 29.7738 29.0664 29.7738C29.7557 29.7738 30.2493 30.1947 30.2493 31.0653V33.123ZM25.9695 29.4475C25.6407 29.4475 25.3743 29.179 25.3743 28.8478C25.3743 28.5166 25.6407 28.248 25.9695 28.248C26.2983 28.248 26.5646 28.5166 26.5646 28.8478C26.5646 29.179 26.2983 29.4475 25.9695 29.4475ZM25.4711 33.123H26.4776V29.873H25.4711V33.123Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.375 14.3012C10.375 16.1265 8.86396 17.6063 7 17.6063C5.13604 17.6063 3.625 16.1265 3.625 14.3012C3.625 12.4758 5.13604 10.9961 7 10.9961C8.86396 10.9961 10.375 12.4758 10.375 14.3012ZM0.25 24.6283C0.25 20.5988 4.74719 18.5689 7 18.5689C9.25281 18.5689 13.75 20.5988 13.75 24.6283C13.75 26.2176 12.3279 27.4297 10.7586 27.1779L8.10911 26.7527C7.3744 26.6348 6.6256 26.6348 5.89089 26.7527L3.24138 27.1779C1.6721 27.4297 0.25 26.2176 0.25 24.6283Z"
        fill="#6039DB"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1976_9703"
        x="-6.25"
        y="7.49609"
        width="52.75"
        height="34"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="4"
          result="effect1_foregroundBlur_1976_9703"
        />
      </filter>
    </defs>
  </svg>
);
const OpenLinkedMessage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="37"
      viewBox="0 0 45 37"
      fill="none"
    >
      <mask
        id="mask0_1976_9731"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="45"
        height="37"
      >
        <rect x="0.75" y="0.5" width="43.5" height="36" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1976_9731)">
        <g filter="url(#filter0_f_1976_9731)">
          <path
            d="M3 16.25C3 18.6138 3.47528 20.9544 4.39871 23.1383C5.32214 25.3222 6.67563 27.3065 8.38191 28.9779C10.0882 30.6494 12.1138 31.9752 14.3432 32.8798C16.5725 33.7844 18.962 34.25 21.375 34.25C23.788 34.25 26.1774 33.7844 28.4068 32.8798C30.6362 31.9752 32.6618 30.6494 34.3681 28.9779C36.0744 27.3065 37.4279 25.3222 38.3513 23.1383C39.2747 20.9544 39.75 18.6138 39.75 16.25L21.375 16.25L3 16.25Z"
            fill="#6039DB"
            fill-opacity="0.09"
          />
        </g>
        <rect
          x="24"
          y="27.5"
          width="8.25"
          height="8.25"
          rx="2"
          fill="#007EBB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.75 33.875H29.7483V32.1689C29.7483 31.7012 29.5706 31.4398 29.2004 31.4398C28.7976 31.4398 28.5872 31.7118 28.5872 32.1689V33.875H27.6219V30.625H28.5872V31.0628C28.5872 31.0628 28.8774 30.5257 29.5671 30.5257C30.2565 30.5257 30.75 30.9467 30.75 31.8173V33.875ZM26.4703 30.1994C26.1414 30.1994 25.875 29.9309 25.875 29.5997C25.875 29.2685 26.1414 29 26.4703 29C26.7991 29 27.0653 29.2685 27.0653 29.5997C27.0653 29.9309 26.7991 30.1994 26.4703 30.1994ZM25.9718 33.875H26.9784V30.625H25.9718V33.875Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.14437 26.2287C3.5144 26.2953 3.88966 26.3286 4.26562 26.3281C5.45388 26.3297 6.61836 25.9953 7.62469 25.3634C8.35031 25.5341 9.10969 25.625 9.89062 25.625C14.88 25.625 19.0312 21.9031 19.0312 17.1875C19.0312 12.4719 14.88 8.75 9.89062 8.75C4.90125 8.75 0.75 12.4719 0.75 17.1875C0.75 19.4459 1.71094 21.4878 3.25687 22.9925C3.47437 23.2044 3.51656 23.3938 3.495 23.5016C3.37914 24.0847 3.11649 24.6288 2.73187 25.0822C2.65203 25.1765 2.59843 25.2901 2.57647 25.4117C2.5545 25.5332 2.56496 25.6584 2.60678 25.7747C2.6486 25.8909 2.72031 25.9941 2.81469 26.0738C2.90906 26.1535 3.02278 26.207 3.14437 26.2287ZM6.375 16.1328C6.09528 16.1328 5.82702 16.2439 5.62922 16.4417C5.43143 16.6395 5.32031 16.9078 5.32031 17.1875C5.32031 17.4672 5.43143 17.7355 5.62922 17.9333C5.82702 18.1311 6.09528 18.2422 6.375 18.2422C6.65472 18.2422 6.92298 18.1311 7.12078 17.9333C7.31857 17.7355 7.42969 17.4672 7.42969 17.1875C7.42969 16.9078 7.31857 16.6395 7.12078 16.4417C6.92298 16.2439 6.65472 16.1328 6.375 16.1328ZM8.83594 17.1875C8.83594 16.9078 8.94706 16.6395 9.14485 16.4417C9.34264 16.2439 9.6109 16.1328 9.89062 16.1328C10.1703 16.1328 10.4386 16.2439 10.6364 16.4417C10.8342 16.6395 10.9453 16.9078 10.9453 17.1875C10.9453 17.4672 10.8342 17.7355 10.6364 17.9333C10.4386 18.1311 10.1703 18.2422 9.89062 18.2422C9.6109 18.2422 9.34264 18.1311 9.14485 17.9333C8.94706 17.7355 8.83594 17.4672 8.83594 17.1875ZM13.4062 16.1328C13.1265 16.1328 12.8583 16.2439 12.6605 16.4417C12.4627 16.6395 12.3516 16.9078 12.3516 17.1875C12.3516 17.4672 12.4627 17.7355 12.6605 17.9333C12.8583 18.1311 13.1265 18.2422 13.4062 18.2422C13.686 18.2422 13.9542 18.1311 14.152 17.9333C14.3498 17.7355 14.4609 17.4672 14.4609 17.1875C14.4609 16.9078 14.3498 16.6395 14.152 16.4417C13.9542 16.2439 13.686 16.1328 13.4062 16.1328Z"
          fill="#FF8F00"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.0177 14.7118C25.8659 14.7374 25.7119 14.7502 25.5577 14.75C25.0702 14.7506 24.5925 14.6222 24.1796 14.3796C23.8819 14.4451 23.5704 14.48 23.25 14.48C21.2031 14.48 19.5 13.0508 19.5 11.24C19.5 9.4292 21.2031 8 23.25 8C25.2969 8 27 9.4292 27 11.24C27 12.1072 26.6058 12.8913 25.9715 13.4691C25.8823 13.5505 25.865 13.6232 25.8738 13.6646C25.9214 13.8885 26.0291 14.0974 26.1869 14.2716C26.2197 14.3078 26.2417 14.3514 26.2507 14.3981C26.2597 14.4448 26.2554 14.4928 26.2382 14.5375C26.2211 14.5821 26.1917 14.6217 26.1529 14.6523C26.1142 14.6829 26.0676 14.7035 26.0177 14.7118ZM24.6923 10.835C24.8071 10.835 24.9171 10.8777 24.9983 10.9536C25.0794 11.0296 25.125 11.1326 25.125 11.24C25.125 11.3474 25.0794 11.4504 24.9983 11.5264C24.9171 11.6023 24.8071 11.645 24.6923 11.645C24.5776 11.645 24.4675 11.6023 24.3863 11.5264C24.3052 11.4504 24.2596 11.3474 24.2596 11.24C24.2596 11.1326 24.3052 11.0296 24.3863 10.9536C24.4675 10.8777 24.5776 10.835 24.6923 10.835ZM23.6827 11.24C23.6827 11.1326 23.6371 11.0296 23.556 10.9536C23.4748 10.8777 23.3648 10.835 23.25 10.835C23.1352 10.835 23.0252 10.8777 22.944 10.9536C22.8629 11.0296 22.8173 11.1326 22.8173 11.24C22.8173 11.3474 22.8629 11.4504 22.944 11.5264C23.0252 11.6023 23.1352 11.645 23.25 11.645C23.3648 11.645 23.4748 11.6023 23.556 11.5264C23.6371 11.4504 23.6827 11.3474 23.6827 11.24ZM21.8077 10.835C21.9224 10.835 22.0325 10.8777 22.1137 10.9536C22.1948 11.0296 22.2404 11.1326 22.2404 11.24C22.2404 11.3474 22.1948 11.4504 22.1137 11.5264C22.0325 11.6023 21.9224 11.645 21.8077 11.645C21.6929 11.645 21.5829 11.6023 21.5017 11.5264C21.4206 11.4504 21.375 11.3474 21.375 11.24C21.375 11.1326 21.4206 11.0296 21.5017 10.9536C21.5829 10.8777 21.6929 10.835 21.8077 10.835Z"
          fill="#111827"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1976_9731"
          x="-5"
          y="8.25"
          width="52.75"
          height="34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_1976_9731"
          />
        </filter>
      </defs>
    </svg>
  );
};
const OpenEmail = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="37"
      viewBox="0 0 44 37"
      fill="none"
    >
      <mask
        id="mask0_1976_9718"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="44"
        height="37"
      >
        <rect x="0.25" y="0.5" width="43.5" height="36" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1976_9718)">
        <g filter="url(#filter0_f_1976_9718)">
          <path
            d="M2.5006 15.502C2.5006 17.8657 2.97588 20.2064 3.89932 22.3903C4.82275 24.5741 6.17624 26.5584 7.88252 28.2299C9.58879 29.9013 11.6144 31.2272 13.8438 32.1318C16.0732 33.0364 18.4626 33.502 20.8756 33.502C23.2886 33.502 25.6781 33.0364 27.9074 32.1318C30.1368 31.2272 32.1624 29.9013 33.8687 28.2299C35.575 26.5584 36.9285 24.5741 37.8519 22.3903C38.7753 20.2064 39.2506 17.8658 39.2506 15.502L20.8756 15.502L2.5006 15.502Z"
            fill="#6039DB"
            fill-opacity="0.09"
          />
        </g>
        <path
          d="M36.041 19.9863L29.5594 26.8386L26.371 24.1984"
          stroke="black"
          stroke-width="3"
          stroke-linecap="square"
        />
        <rect
          x="0.25"
          y="11.002"
          width="17.25"
          height="12"
          rx="2"
          fill="#52B5F9"
        />
        <path
          d="M8.45663 17.4745C8.7093 17.6439 9.03928 17.6439 9.29196 17.4745L16.8941 12.3775C17.5096 11.9648 17.2175 11.0045 16.4764 11.0045H1.27214C0.5311 11.0045 0.238977 11.9648 0.854474 12.3775L8.45663 17.4745Z"
          fill="#111827"
          fill-opacity="0.21"
        />
        <path
          d="M9.29264 5.88096C9.03996 5.71155 8.70998 5.71155 8.45731 5.88096L0.855154 10.978C0.239656 11.3907 0.53178 12.3509 1.27282 12.3509L16.4771 12.3509C17.2182 12.3509 17.5103 11.3907 16.8948 10.978L9.29264 5.88096Z"
          fill="#4494CD"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1976_9718"
          x="-5.49939"
          y="7.50195"
          width="52.75"
          height="34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_1976_9718"
          />
        </filter>
      </defs>
    </svg>
  );
};
const TextIcon = () => (
  <svg
    fill="#000000"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
  >
    <path d="M17,6H7A1,1,0,0,0,7,8h4v9a1,1,0,0,0,2,0V8h4a1,1,0,0,0,0-2Z" />
  </svg>
);

export const Imaged = ({ stepType }: { stepType: string }) => {
  switch (stepType) {
    case "email":
      return <flowIcons.Email />;
    case "linkedin":
      return <flowIcons.LinkedIn />;
    case "timer":
      return <flowIcons.Clock />;
    default:
      return <p className="invisible">none</p>;
  }
};

const Duplicate = (props: any) => {
  return (
    <svg
      fill="#000000"
      width="20px"
      height="20px"
      viewBox="0 0 35 35"
      data-name="Layer 2"
      id="a5b357d0-b6bb-4b51-acaf-aaa20a4d1704"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20.717,34.748H3.616A3.37,3.37,0,0,1,.25,31.381v-17.1a3.369,3.369,0,0,1,3.366-3.365h17.1a3.368,3.368,0,0,1,3.365,3.365v17.1A3.369,3.369,0,0,1,20.717,34.748ZM3.616,13.416a.866.866,0,0,0-.866.865v17.1a.867.867,0,0,0,.866.867h17.1a.867.867,0,0,0,.865-.867v-17.1a.865.865,0,0,0-.865-.865Z" />
      <path d="M31.384,24.079H22.837a1.25,1.25,0,1,1,0-2.5h8.547a.867.867,0,0,0,.866-.866V3.618a.866.866,0,0,0-.866-.865h-17.1a.866.866,0,0,0-.866.865v8.548a1.25,1.25,0,0,1-2.5,0V3.618A3.369,3.369,0,0,1,14.279.253H31.384A3.369,3.369,0,0,1,34.75,3.618v17.1A3.37,3.37,0,0,1,31.384,24.079Z" />
    </svg>
  );
};
const Warning = (props: any) => {
  return (
    <svg
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      width="20px"
      height="20px"
      y="0px"
      viewBox="0 0 360 360"
      style={{
        enableBackground: "new 0 0 360 360",
      }}
      xmlSpace="preserve"
      {...props}
    >
      <g id="XMLID_994_">
        <polygon
          id="XMLID_998_"
          style={{
            fill: "#ec4343",
          }}
          points="0,343.167 180,16.833 360,343.167  "
        />
        <polygon
          id="XMLID_43_"
          style={{
            fill: "#DEDFE8",
          }}
          points="202.059,245.294 157.941,245.294 153.529,139.412 206.471,139.412  "
        />
        <rect
          id="XMLID_40_"
          x={157.941}
          y={271.765}
          style={{
            fill: "#DEDFE8",
          }}
          width={44.118}
          height={35.294}
        />
        <polygon
          id="XMLID_1003_"
          style={{
            fill: "#ec4343",
          }}
          points="180,16.833 180,343.167 360,343.167  "
        />
        <rect
          id="XMLID_1006_"
          x={180}
          y={271.765}
          style={{
            fill: "#C9C7D7",
          }}
          width={22.059}
          height={35.294}
        />
        <polygon
          id="XMLID_1009_"
          style={{
            fill: "#DEDFE8",
          }}
          points="180,139.412 180,245.294 202.059,245.294 206.471,139.412  "
        />
      </g>
    </svg>
  );
};
export const flowIcons = {
  Email,
  LinkedIn,
  Clock,
  HasEmail,
  OpenLinkedMessage,
  AcceptLinkedInvite,
  OpenEmail,
  TextIcon,
  Duplicate,
  Warning,
};
